// extracted by mini-css-extract-plugin
export default {"top-parameters":"kdZtI","top-parameters--max":"cttwz","top-parameter":"Ef6pS","top-parameter__text":"oxeR2","picture":"feXlK","picture-wrapper":"oBSmT"};